import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationSerializer from 'lumen/serializers/application';

export default class DesiredCompetitorSerializer extends ApplicationSerializer {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  serialize(snapshot: Snapshot) {
    return {
      // Backend only needs the ID of the competitor.
      id: snapshot.id,
    };
  }
}
